import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyCPkR7idJVNGw0WJqUcEn9hQxwooI9JRdY',
  authDomain: 'vue-firebase-demo-73897.firebaseapp.com',
  databaseURL: 'https://vue-firebase-demo-73897.firebaseio.com',
  projectId: 'vue-firebase-demo-73897',
  storageBucket: 'vue-firebase-demo-73897.appspot.com',
  messagingSenderId: '52078479849',
  appId: '1:52078479849:web:0263e7a7d9adc8fe8ee378',
};

firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();
const db = firebase.firestore();
const storage = firebase.storage();

export default { auth, db, storage };
